<template>
<div class="primary text-center m4u_text--text">

<span>&#169;</span>2021 Memories For Us

</div>


</template>

<script>

export default {
  name: "Footer",

  data() {
    return {

    };
  },
 mounted() {

  },

  computed: {
  user(){
    return this.$store.state.user
  },

    loginState(){
    return this.$store.state.loginState
  },

            btnProps()  {
          let props = {}
          switch(this.$vuetify.breakpoint.name) {
            case 'xs':
              props.color = 'blue'
              props['x-small'] = true
              break
            case 'sm':
              props.color = 'blue'
              props['small'] = true
              break  
            case 'lg':
              props.color = 'green'
              props['large'] = true
              break
             case 'xl':
              props.color = 'purple'
              props['x-large'] = true
              break 
            default: 
              props.color = 'red'
          }
          return props
        }
        
  },

  methods: {

  }

};

</script>

<style>

</style>